module.exports = __webpack_public_path__ + "img/video.b0335558.svg";